module.exports = __webpack_public_path__ + "img/uploadid.e914556f.svg";